import React from 'react';
import axios from 'axios';
import './css/Header.css';

import logoTelegram from '../../assets/img/telegram.svg';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      width:0,
      height:0
    }
    this.onWindowResize = this.onWindowResize.bind(this)
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      this.forceUpdate();
    });
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  }
  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize(){
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
    this.forceUpdate();
  }

  clickHandler(e, url){
    e.preventDefault();
    this.props.history.push(url);
  }

  cerrarSesion(){
    sessionStorage.clear();
    this.props.history.push('/');
  }

  nivelAcceso(){
    const {menu} = this.props;
    const nivel = sessionStorage.getItem('tipo');
    //CAMBIAR POR NIVELES DE ACCESO DEL NUEVO
    switch (nivel) {
      case "1":
        return (menu.mesa);
      case "2":
        return (menu.agente);
      case "3":
        return (menu.agente);
      case "4":
        return (menu.admin);
      default:
        return (menu.publico);
    }
  }
/*
  cerrarSesion(){
    const config = {
      headers:{
        authorization:sessionStorage.getItem('token')
      }
    };
    //CAMBIAR A RUTA CORRESPONDIENTE
    const url = localStorage.getItem('apiUrl') + '/api/deposito/users/logout';
    axios.post(url, config)
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      sessionStorage.clear();
      this.props.history.push('/');
    })
  }
*/

  menuDerecha(){
    const token = sessionStorage.getItem('token');
    if (token) {
      return(
        <div style={{display:'flex', flexDirection:'row', height:'100%', justifyItems:'flex-end', alignItems:'center'}}>
          <span onClick={(e)=>this.clickHandler(e, "/telegram")} style={{marginRight:10, cursor:'pointer'}}>
            <img 
              src={logoTelegram}
              height={30}
            />
          </span>
          <span
            className="Opcion"
            style={{cursor:'pointer'}}
            onClick={()=>this.cerrarSesion()}
          >
            Cerrar Sesión
          </span>
        </div>
      )
    } else {
      return(
        <a
          className="Opcion"
          href="/login"
          onClick={(e)=>this.clickHandler(e, "/login")}
        >
          Ingresar
        </a>
      )
    }
  }

  render(){
    const {width} = this.state;
    if (width >= 1040) {
      return(
        <div className="Header">
          <div className="Container">
            <a
              style={{height:'100%',textDecoration:'none'}}
              href={'/'}
              onClick={(e)=>this.clickHandler(e, '/')}
            >
              <span className="Titulo" style={{fontSize:36, color:'white'}}>
                Ministerio de
                <br style={{height:0}}/>
                Desarrollo Humano
              </span>
            </a>
            <div className="Main">
              {this.nivelAcceso().map((item,index) => {
                return(
                  <a
                    className="Opcion"
                    href={item.url}
                    key={index}
                    onClick={(e)=>this.clickHandler(e, item.url)}
                  >
                    {item.titulo}
                  </a>
                )
              })}
            </div>
            <div className="Derecha">
              {this.menuDerecha()}
            </div>
          </div>
        </div>
      );
    } else {
      return(
        <div className="Header">
          <div className="Container">
            <a
              style={{height:'100%',textDecoration:'none'}}
              href={'/'}
              onClick={(e)=>this.clickHandler(e, '/')}
            >
              <span className="Titulo" style={{fontSize:36, color:'white'}}>
                Ministerio de
                <br style={{height:0}}/>
                Desarrollo Humano
              </span>
            </a>
            <div className="Derecha">
              <span
                className="material-icons Accion"
                style={{marginRight:20, backgroundColor:'#00a6e5', padding:'10px 12px'}}
                title="Menú"
                onClick={() => this.props.abrirMenu(this.nivelAcceso())}
              > menu </span>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Header;
